// Locale mapping for correct date formatting (locale code -> BCP 47 identifier)
export const LOCALE_TO_BCP47_MAP = {
  en: 'en-GB',
  de: 'de-DE',
  fr: 'fr-FR',
  nl: 'nl-NL',
  'ch-de': 'de-CH',
  'ch-fr': 'fr-CH',
};

export default defineI18nConfig(() => {
  return {
    numberFormats: {
      en: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      de: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      fr: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      nl: {
        currency: {
          style: 'currency',
          currency: 'EUR',
        },
      },
      'ch-de': {
        currency: {
          style: 'currency',
          currency: 'CHF',
        },
      },
      'ch-fr': {
        currency: {
          style: 'currency',
          currency: 'CHF',
        },
      },
    },
    datetimeFormats: {
      // https://kazupon.github.io/vue-i18n/guide/datetime.html
      'en-GB': {
        short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
        long: {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      'de-DE': {
        short: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      'fr-FR': {
        short: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      'nl-NL': {
        short: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      'de-CH': {
        short: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
      'fr-CH': {
        short: {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        },
      },
    },
    fallbackLocale: 'en',
  };
});
